module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/5ImfH2/tc-custom/9781612437415.jpg?1726444214910",
      "alt": "This image is the cover for the book Baking Magic with Aquafaba"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Baking Magic with Aquafaba\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Delicious egg-free baked goods using aquafaba."), _c('br'), _c('br'), _vm._v(" Move over tofu, there’s a miraculous new egg replacement in town! With baking properties so amazing it can create fluffy quiche and light meringue, aquafaba is the breakthrough ingredient that will revolutionize your vegan baking."), _c('br'), _c('br'), _vm._v(" Baking Magic with Aquafaba offers up recipes for creamy sweet treats and rich savory dishes, such as:"), _c('br'), _c('br'), _vm._v(" • Key Lime Mousse"), _c('br'), _vm._v(" • Chocolate Pirouette Cookies"), _c('br'), _vm._v(" • Lemon Meringue Pie"), _c('br'), _vm._v(" • Birthday Cake Waffles"), _c('br'), _vm._v(" • Pistachio Macarons"), _c('br'), _vm._v(" • Sponge Cake"), _c('br'), _vm._v(" • Rocky Road Ice Cream"), _c('br'), _vm._v(" • Cranberry Orange Scones"), _c('br'), _vm._v(" • Pesto Flatbread"), _c('br'), _vm._v(" • Baked “Mozzarella” Sticks"), _c('br'), _vm._v(" • Hollandaise Sauce• Garlic Aioli"), _c('br'), _c('br'), _vm._v(" This cruelty-free ingredient is as versatile as it is tasty. It can be whipped into cakes, pie fillings, delicious icings and used as a fat substitute for butters, aiolis and cheeses, without sacrificing texture or flavor. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kelsey Kinser\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Kelsey Kinser is a professionally trained chef and recipe developer working in New York City.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Ulysses Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0